import { GET_CHATBOT_SUGGESTIONS } from '@/queries';

export const useChatbotSuggestions = async () => {
  try {
    const { data } = await useGraphQL(
      GET_CHATBOT_SUGGESTIONS
    );
    return data?.value?.data?.chatOpeningSuggestion;
  } catch (error) {
    console.log('Error: Unable to get Chatbot Suggestions');
  }
}
